module.exports = __webpack_public_path__ + "static/assets/0283e0a0fbda42b5aab1259c7d26c867.png";